/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SpaceEntry } from '../models/space-entry';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class SpacesControllerService extends DataBaseService {

  /**
   * Path part for operation spacesControllerGetSpacesCount
   */
  static readonly SpacesControllerGetSpacesCountPath = '/v1/spaces/count';

  /**
   * Get spaces count
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSpacesCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSpacesCount$Response(params?: {
    search?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerGetSpacesCountPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get spaces count
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSpacesCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSpacesCount(params?: {
    search?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.getSpacesCount$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation spacesControllerGetSpacesForCurrentUser
   */
  static readonly SpacesControllerGetSpacesForCurrentUserPath = '/v1/spaces/my';

  /**
   * Get my spaces
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSpacesForCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSpacesForCurrentUser$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<SpaceEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerGetSpacesForCurrentUserPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SpaceEntry>>;
      })
    );
  }
  /**
   * Get my spaces
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSpacesForCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSpacesForCurrentUser(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<SpaceEntry>> {

    return this.getSpacesForCurrentUser$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SpaceEntry>>) => r.body as Array<SpaceEntry>)
    );
  }

  /**
   * Path part for operation spacesControllerGetUserSpaces
   */
  static readonly SpacesControllerGetUserSpacesPath = '/v1/spaces/user/{id}';

  /**
   * Get user spaces
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserSpaces()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserSpaces$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<SpaceEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerGetUserSpacesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SpaceEntry>>;
      })
    );
  }
  /**
   * Get user spaces
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserSpaces$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserSpaces(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<SpaceEntry>> {

    return this.getUserSpaces$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SpaceEntry>>) => r.body as Array<SpaceEntry>)
    );
  }

  /**
   * Path part for operation spacesControllerActivateSpace
   */
  static readonly SpacesControllerActivateSpacePath = '/v1/spaces/{id}/activate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateSpace()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateSpace$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerActivateSpacePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateSpace$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateSpace(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<void> {

    return this.activateSpace$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation spacesControllerDeActivateSpace
   */
  static readonly SpacesControllerDeActivateSpacePath = '/v1/spaces/{id}/deactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deActivateSpace()` instead.
   *
   * This method doesn't expect any request body.
   */
  deActivateSpace$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerDeActivateSpacePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deActivateSpace$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deActivateSpace(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<void> {

    return this.deActivateSpace$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation spacesControllerSpaceEndUserActivate
   */
  static readonly SpacesControllerSpaceEndUserActivatePath = '/v1/spaces/{id}/end-user-activate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `spaceEndUserActivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  spaceEndUserActivate$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerSpaceEndUserActivatePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `spaceEndUserActivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  spaceEndUserActivate(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<void> {

    return this.spaceEndUserActivate$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation spacesControllerSpaceEndUserDeActivate
   */
  static readonly SpacesControllerSpaceEndUserDeActivatePath = '/v1/spaces/{id}/end-user-deactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `spaceEndUserDeActivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  spaceEndUserDeActivate$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerSpaceEndUserDeActivatePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `spaceEndUserDeActivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  spaceEndUserDeActivate(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<void> {

    return this.spaceEndUserDeActivate$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation spacesControllerGetSpace
   */
  static readonly SpacesControllerGetSpacePath = '/v1/spaces/{id}';

  /**
   * Get single space by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSpace()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSpace$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<SpaceEntry>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerGetSpacePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SpaceEntry>;
      })
    );
  }
  /**
   * Get single space by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSpace$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSpace(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<SpaceEntry> {

    return this.getSpace$Response(params).pipe(
      map((r: StrictHttpResponse<SpaceEntry>) => r.body as SpaceEntry)
    );
  }

  /**
   * Path part for operation spacesControllerGetAllSpaces
   */
  static readonly SpacesControllerGetAllSpacesPath = '/v1/spaces';

  /**
   * Get all spaces
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSpaces()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSpaces$Response(params?: {
    filterCriteria?: any;
    search?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<SpaceEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerGetAllSpacesPath, 'get');
    if (params) {
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SpaceEntry>>;
      })
    );
  }
  /**
   * Get all spaces
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllSpaces$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSpaces(params?: {
    filterCriteria?: any;
    search?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<SpaceEntry>> {

    return this.getAllSpaces$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SpaceEntry>>) => r.body as Array<SpaceEntry>)
    );
  }

  /**
   * Path part for operation spacesControllerCreate
   */
  static readonly SpacesControllerCreatePath = '/v1/spaces';

  /**
   * Create a new space
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: SpaceEntry
  }): Observable<StrictHttpResponse<SpaceEntry>> {

    const rb = new RequestBuilder(this.rootUrl, SpacesControllerService.SpacesControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SpaceEntry>;
      })
    );
  }
  /**
   * Create a new space
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: SpaceEntry
  }): Observable<SpaceEntry> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<SpaceEntry>) => r.body as SpaceEntry)
    );
  }

}
